var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconZocialFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.749,
    height: 12.544,
    viewBox: "0 0 6.749 12.544",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_zocial-facebook",
    "data-name": "Icon zocial-facebook",
    d: "M13.257,6.736v-2.4h1.932v-1.2a3.152,3.152,0,0,1,.846-2.22A2.692,2.692,0,0,1,18.086,0h1.919V2.4H18.086a.423.423,0,0,0-.338.207.84.84,0,0,0-.151.508V4.34h2.408v2.4H17.6v5.808H15.189V6.736Z",
    transform: "translate(-13.257 0)",
    fill: "#f49a56"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZocialFacebook);
export default __webpack_public_path__ + "static/media/icon-zocial-facebook.795d50fff123f5c4d0eb468aaa84721b.svg";
export { ForwardRef as ReactComponent };